const validate = (values) => {
  const errors = {};
  if (!values.title) {
    errors.title = 'El titulo no debe ser una campo vacio';
  } else if (values && values.title.length > 50) {
    errors.title = 'No debe tener mas de 50 caracteres';
  }
  return errors;
};

export default validate;
